import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";

import { useOrganisationData } from "@RequestFormV2/sections/Organisation/context/useOrganisationData";
import { isCostRecoveryRequiredUnset } from "@RequestFormV2/sections/Organisation/context/isCostRecoveryRequiredUnset";

type OrganisationFields = ReturnType<typeof useOrganisationData>["organisationFields"];

export function useOrganisationHandlers(organisationFields: OrganisationFields) {
  const { setValue, getValues } = useFormContext();

  const costRecoveryField = useMemo(
    () => organisationFields?.find((f) => f.field_id === "cost_recovery_required"),
    [organisationFields],
  );

  const yesValue = useMemo(
    () => (costRecoveryField?.dropdown_values as any[])?.find((item) => item.key === "Yes")?.value ?? "True",
    [costRecoveryField],
  );

  useEffect(() => {
    if (!costRecoveryField?.dropdown_values?.length) return;
    const currentValue = getValues("organizational.cost_recovery_required");
    if (!isCostRecoveryRequiredUnset(currentValue)) return;
    setValue("organizational.cost_recovery_required", yesValue);
  }, [costRecoveryField, yesValue, setValue, getValues]);

  return { yesValue };
}
